import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { InlineStatus } from 'components/InlineStatus';
import { SlackChannelList } from 'components/SlackChannelList';
import { useGeoEventSlackChannels } from 'features/geoEvents/hooks/useGeoEventSlackChannels';
import { isAuthorizedUser } from 'shared/utils';
import { useAuthState } from 'state/useAuthState';
import { getSlackChannelLabelKey } from './GeoEventSlackChannels.utils';

type GeoEventSlackChannelsProps = {
  geoEventId?: number;
};

export const GeoEventSlackChannels = (
  props: GeoEventSlackChannelsProps,
): JSX.Element | null => {
  const { geoEventId } = props;
  const { t } = useTranslation();
  const {
    user,
    permissions: { isInternalUser },
  } = useAuthState();
  const { slackChannels, isLoading, isError } = useGeoEventSlackChannels({
    geoEventId,
  });

  if (!isInternalUser || !isAuthorizedUser(user)) return null;

  const header = (
    <Typography variant="watchduty-section-header">
      {t('slackChannels.title')}
    </Typography>
  );

  if (isLoading || isError) {
    return (
      <>
        {header}
        <InlineStatus
          status={isLoading ? 'loading' : 'error'}
          errorMessage={t('geoEvent.slackChannels.error')}
          fullWidth
        />
      </>
    );
  }

  return (
    <>
      {header}
      <SlackChannelList
        channels={slackChannels.map((channel) => ({
          label: t(getSlackChannelLabelKey(channel)),
          channelName: channel.channelName,
          channelId: channel.channelId,
        }))}
      />
    </>
  );
};
